import { DataGridCell, exportDataGrid } from 'devextreme/excel_exporter'
import dxDataGrid from 'devextreme/ui/data_grid'
import { Workbook } from 'exceljs'
import { saveAs } from 'file-saver'
import { getFieldType, getFileDate } from '@evologi/shared/data-access-api'

export function exportGrid(
  component: dxDataGrid,
  fileName: string,
  sheetName = 'Sheet',
  customizeCell?: (options: {
    gridCell?: DataGridCell
    excelCell?: any
  }) => void,
  catalog?: string,
): void {
  const workbook = new Workbook()
  const worksheet = workbook.addWorksheet(sheetName)

  exportDataGrid({
    component,
    worksheet,
    selectedRowsOnly: !!component.getSelectedRowKeys().length,
    autoFilterEnabled: true,
    loadPanel: { enabled: false },
    customizeCell,
  }).then(() => {
    const columns = component.option('columns') || []

    const headerRow = worksheet.getRow(1)

    worksheet.columns.forEach((c, index) => {
      const headerCell = headerRow.getCell(index + 1)
      const columnTitle = headerCell.value?.toString() || ''
      c.numFmt = getFieldType(columnTitle)
    })

    if (component.getSelectedRowKeys().length && worksheet.rowCount < 2) {
      const selectedRows = component.getSelectedRowsData()

      selectedRows.forEach((row) => {
        const values = columns.map((c: any) => {
          const field = typeof c === 'object' ? c.dataField : c
          return row[field]
        })

        const excelRow = worksheet.addRow(values)

        // invoke customizeCell for each cell
        excelRow.eachCell((cell, colIndex) => {
          const columnDef = columns[colIndex - 1]
          const column =
            typeof columnDef === 'string'
              ? { dataField: columnDef, caption: columnDef }
              : columnDef

          if (customizeCell) {
            customizeCell({
              gridCell: { rowType: 'data', data: row, column },
              excelCell: cell,
            })
          }
        })
      })
    }

    const stringDate = getFileDate()

    return workbook.xlsx
      .writeBuffer()
      .then((buffer: BlobPart) =>
        saveAs(
          new Blob([buffer], { type: 'application/octet-stream' }),
          `${fileName}_${stringDate}.xlsx`,
        ),
      )
  })
}

export function getGridFilterKeys(filters: any[]): string[] {
  const keys: string[] = []

  if (!filters.length) {
    return keys
  }

  // Check single filter
  if (!filters.some((f) => f instanceof Array)) {
    keys.push(filters[2])
    return keys
  }

  for (const filter of filters) {
    if (filter instanceof Array) {
      keys.push(filter[2])
    }
  }

  return keys
}
